import { BallAnimation } from '../slices/ball/ball.slice.types.ts';
import { KeyWordPosition } from '../slices/story-reading/story-reading.slice.types.ts';

export const mapStorySentenceAnimationSingleLine = (
  startPosition: KeyWordPosition,
  finalPosition: KeyWordPosition,
  duration: number
): BallAnimation => ({
  fromXPosition: startPosition.startX,
  toXPosition: finalPosition.endX,
  duration,
  rowIndex: startPosition.line,
});
